import { QueryFilters, useQueryClient } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';

export function useLatestDataUpdatedAt(filters: QueryFilters) {
  const queryClient = useQueryClient();

  return useSyncExternalStore(
    (cb) => {
      const unsubscribe = queryClient.getQueryCache().subscribe(cb);

      return unsubscribe;
    },
    () => {
      let latest = 0;

      for (const query of queryClient.getQueryCache().findAll(filters)) {
        latest = Math.max(latest, query.state.dataUpdatedAt || 0);
      }

      return latest;
    },
  );
}
